<template>
  <div class="account-settings-info-right">
    <div class="account-settings-info-title">
      <span>{{ $route.meta.subTitle }}</span>
    </div>

    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      layout="horizontal"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="旧密码" prop="pwd">
        <a-input-password
          class="vd-input-s"
          v-model="form.pwd"
          placeholder="旧密码"
          type="password"
          autocomplete="off"
        />
        <p style="margin: 0px;color: #999999">
          4-16位，并包含字母、数字和特殊字符中的两种
        </p>
      </a-form-model-item>
      <a-form-model-item label="新密码" prop="new_pwd">
        <a-input-password
          class="vd-input-s"
          v-model="form.new_pwd"
          placeholder="新密码"
          type="password"
          autocomplete="off"
        />
      </a-form-model-item>
      <a-form-model-item label="确认新密码" prop="new_pwd_twice">
        <a-input
          class="vd-input-s"
          v-model="form.new_pwd_twice"
          placeholder="确认新密码"
          type="password"
          autocomplete="off"
        />
      </a-form-model-item>
    </a-form-model>
    <!--    <a-button>-->
    <a-button type="primary" style="margin-right: 8px" @click="add">
      保存
    </a-button>
    <!--      重置-->
    <!--    </a-button>-->
  </div>
</template>

<script>
import { modify_password } from '@/api'
import md5 from 'js-md5'
import store from '@/store'

export default {
  name: 'addAdmin',
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (value !== '') {
          let length = value.length
          if (length < 4) {
            callback(new Error('长度不足'))
          }
          if (length > 16) {
            callback(new Error('超出长度'))
          }
          const reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{4,16}$/
          if (!reg.test(value)) {
            callback(new Error('密码格式不正确'))
          }
        }
        callback()
      }
    }
    let validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (value !== '') {
          let length = value.length
          if (length < 4) {
            callback(new Error('长度不足'))
          }
          if (length > 16) {
            callback(new Error('超出长度'))
          }
          if (value === this.form.pwd) {
            callback(new Error('与旧密码相同'))
          }
          const reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{4,16}$/
          if (!reg.test(value)) {
            callback(new Error('密码格式不正确'))
          }
        }
        callback()
      }
    }
    let validatePassTwice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.new_pwd) {
        callback(new Error('两次密码不匹配'))
      } else {
        callback()
      }
    }
    return {
      areaTree: [],
      roleList: [],
      labelCol: { span: 3 },
      wrapperCol: { span: 14 },
      form: {
        pwd: '',
        new_pwd: '',
        new_pwd_twice: '',
      },
      rules: {
        pwd: [{ required: true, validator: validatePass, trigger: 'change' }],
        new_pwd: [
          { required: true, validator: validateNewPass, trigger: 'change' },
        ],
        new_pwd_twice: [
          { required: true, validator: validatePassTwice, trigger: 'change' },
        ],
      },
    }
  },
  created() {},
  methods: {
    add: function() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          modify_password({
            pwd: md5(this.form.pwd),
            new_pwd: this.form.new_pwd,
            new_pwd_twice: this.form.new_pwd_twice,
          }).then((res) => {
            if (res['code'] === 1) {
              this.$message.success('更新成功')

              store.commit('SET_MENUS', [])
              store.commit('SET_ROLES', [])
              store.commit('SET_USER_INFO', {})
              localStorage.clear()
              this.$router.push({ path: '/user/login', replace: true })
            } else {
              this.$message.warning(res['msg'])
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped></style>
